import React, { useState } from 'react';
import { Confirm  } from 'semantic-ui-react';

import { VscCheck, VscChromeClose, VscEdit } from "react-icons/vsc";
import { AdminPermissionModal } from '../../../Shared/AdminPermissionModal';
import { NodeAuthorizationForm } from '../../RequestPermission/NodeAuthorizationForm';
import { AdminPermissionAPI } from '../../../../api/admin_permission';
import { useAuth } from '../../../../hooks';
import { useParams } from "react-router";
import './ItemAdminPermission.css';


const adminPermissionController = new AdminPermissionAPI();

export function ItemAdminPermission(props) {
  const { adminPermission, key, onReload } = props;
  const { statusRequest } = useParams();
 

  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState)

  const [showConfirm, setShowConfirm] = useState(false);
  const [showConfirmOtp, setShowConfirmOtp] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);
  const onOpenCloseConfirmOtp = () => setShowConfirmOtp((prevState) => !prevState);
  //open admin permission modal
  const openUpdateAdminPermissionModal = () => {
    setTitleModal(`Update Permission`)
    onOpenCloseModal();
  };

  //aprovar permission
  const onApprovePermissionConfirm = async () => {
    try {
        await adminPermissionController.approvePermission(accessToken, adminPermission.id);
        onOpenCloseConfirm();
        onReload();
    } catch (error) {
        console.error(error);
    }
  };

  // delete permission
  const onDeletePermissionConfirm = async () => {
    try {
        await adminPermissionController.deletePermission(accessToken, adminPermission.id);
        onOpenCloseConfirm();
        onReload();
    } catch (error) {
        console.error(error);
    }
  };

   //send otp permission
   const onOtpPermissionConfirm = async () => {
    try {
        await adminPermissionController.sendOtpPermission(accessToken, adminPermission.id);
        onOpenCloseConfirmOtp();
        onReload();
    } catch (error) {
        console.error(error);
    }
  };
  const openConfirmApprovePermission = () => {
    setIsDelete(false);
    setConfirmMessage(
        adminPermission.status === 'APPROVE'
            ? `Delete Admin Permission`
            : `Approve Admin Permission`
    );
    onOpenCloseConfirm()
  };

  const openConfirmDeletePermission = () => {
    setIsDelete(true);
    setConfirmMessage(`Delete Admin Permission`)
    onOpenCloseConfirm()
  };
  const openConfirmSendOtpPermission = () => {
    
    setConfirmMessage(`Send OTP`)
    onOpenCloseConfirmOtp()
  };
  return (
    <>
      <tbody>
        <tr className='item-adminPermission__body' key={key}>
          <td>{adminPermission.entity}</td>
          <td>{adminPermission.nameTechnicalContact}</td>
          <td>{adminPermission.emailTechnicalContact}</td>
          <td>{adminPermission.networkName}</td>
          
          <td>{adminPermission.status}</td>
          <td>
              <div className='market-item_buttons-actions'>
                <button className='bttn-show' icon="true" onClick={openUpdateAdminPermissionModal}>
                  <VscEdit size="20" />
                </button>
                
                { statusRequest==="CONFIRMED" ? 
                <button className='bttn-check' icon="true" onClick={openConfirmApprovePermission}>
                  <VscCheck size="20" />
                </button>
                :
                <></>
                }
                
                 { statusRequest==="PENDING" ? 
                <button className="bttn-check" icon="false" onClick={openConfirmSendOtpPermission}>
                  <VscCheck size="16" />
                  OTP
                </button>
                :
                <></>
                }
                <button className='bttn-delete' icon="true" onClick={openConfirmDeletePermission}>
                  <VscChromeClose size="20" />
                </button>
              </div>
          </td>
        </tr>
      </tbody>

      <AdminPermissionModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <NodeAuthorizationForm
          close={onOpenCloseModal}
          onReload={onReload}
          permission={adminPermission}
      />
      </AdminPermissionModal>

      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDelete ? onDeletePermissionConfirm : onApprovePermissionConfirm}
        content={confirmMessage}
        size='tiny'
      />
      <Confirm
        open={showConfirmOtp}
        onCancel={onOpenCloseConfirmOtp}
        onConfirm={onOtpPermissionConfirm}
        content={confirmMessage}
        size='tiny'
      />
    </>
  )
}
